/**
 * CalendarSettingsModal - Modal de configurações de calendários
 *
 * Abre as 3 abas (Meus calendários / Compartilhamento / Integrações)
 * dentro de um Dialog premium, sem navegar para outra página.
 *
 * RELEASE:
 *   2026-06-24 v1.0.0 - Versão inicial (substitui navegação para /tenant/calendar/settings)
 */

import { Calendar as CalendarIcon } from 'lucide-react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from '@/components/ui/dialog';
import { CalendarSettingsContent } from './CalendarSettingsContent';

interface CalendarSettingsModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function CalendarSettingsModal({ open, onOpenChange }: CalendarSettingsModalProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-5xl w-[95vw] h-[85dvh] md:h-[80dvh] flex flex-col p-0 gap-0 overflow-hidden sm:rounded-lg">
        {/* Capa premium padronizada (mesmo padrão do modal de anotações) */}
        <DialogHeader className="px-4 sm:px-6 py-3 sm:py-4 border-b bg-gradient-to-r from-primary/5 via-primary/3 to-transparent shrink-0">
          <div className="flex items-start gap-3 min-w-0 pr-8">
            <div className="p-1.5 sm:p-2 bg-primary/10 rounded-lg shrink-0">
              <CalendarIcon className="h-4 w-4 sm:h-5 sm:w-5 text-primary" />
            </div>
            <div className="flex flex-col min-w-0">
              <DialogTitle className="truncate">Configurações de calendários</DialogTitle>
              <DialogDescription className="text-xs line-clamp-2 sm:line-clamp-none">
                Gerencie seus calendários, compartilhamentos e integrações Google.
              </DialogDescription>
            </div>
          </div>
        </DialogHeader>
        <div className="flex-1 min-h-0 overflow-y-auto px-6 py-5">
          <CalendarSettingsContent />
        </div>
      </DialogContent>
    </Dialog>
  );
}

